import {WebMessagesActions, WebMessagesActionsTypes} from "@ispm/core/store/webMessages.actions";

export interface IWebMessagesState {
  initiateHandshakeToken: string;
}

const InitWebMessagesState: IWebMessagesState = {
  initiateHandshakeToken: ""
}

export function webMessagesReducer(state: IWebMessagesState = InitWebMessagesState, action: WebMessagesActions): IWebMessagesState {
  switch (action.type) {
    case WebMessagesActionsTypes.UPDATE_INITIATE_HANDSHAKE_TOKEN:
      return {...state, initiateHandshakeToken: action.payload.value};
    default:
      return state;
  }
}
